import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
export const organizationProcessDatasource = createCrudVuexModule({
  namespaced: true,
  path: "/process-datasource",
  options: { localizedFields: ["name", "description", "note"] },
  state: {
    selectedDataCategory: false,
  },
  getters: {
    selectedDataCategory: (state) => state.selectedDataCategory,
  },
  mutations: {
    selectedDataCategory: (state, value) => (state.selectedDataCategory = value),
  },

  actions: {
    async save({ dispatch }, { payload, changeInAllHierarchy }) {
      if (payload._id) {
        return dispatch("update", { payload, changeInAllHierarchy });
      } else {
        return dispatch("create", payload);
      }
    },

    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/process-datasource`, { item: payload });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, { payload, changeInAllHierarchy }) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/process-datasource`, { item: payload, changeInAllHierarchy });

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/process-datasource/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async markAsComplete({ getters, commit, dispatch }, id) {
      await rest.put(`/process-datasource/complete/`, { id });
    },

    async updateNote({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`/process-datasource/note`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
